module.exports = __webpack_public_path__ + "static/media/7.8.66c0a4eb.png";